import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.css']
})
export class AlertPopupComponent implements OnInit {
  @Input() errorMessage;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() changeFlag: EventEmitter<any> = new EventEmitter();
  constructor(public activeModal: NgbActiveModal, private translate: TranslateService) { }

  ngOnInit() {
    this.passEntry.emit(this.errorMessage);
  }

  closeModal(){
    this.activeModal.dismiss('Cross click');
    this.changeFlag.emit(this.errorMessage);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/popups/alert-popup/alert-popup.component.ts